export const setSidebar = showSidebar => ({
  type: "SET_SIDEBAR",
  showSidebar
});
